import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  BackgroundColors,
  AbsoluteWhiteColors,
} from '@picsart/design-system/foundation/colors';
import { Effects } from '@picsart/design-system/foundation/effects';
import { Easings } from '@picsart/design-system/foundation/easings';
import { Breakpoints } from '@picsart/design-system/foundation/responsive';
import { canHover } from '@picsart/design-system/styleUtils/hoverTouch';

const useStyles = createUseStyles(
  {
    '@keyframes fadeOutScale': {
      '0%': {
        opacity: 1,
        transform: 'scale(1)',
      },
      '100%': {
        opacity: 0,
        transform: 'scale(0.95)',
      },
    },
    preview: {
      position: 'relative',
      width: '100%',
      height: 144,
      borderRadius: CornerRadius.r12,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: BackgroundColors.tint1, // Match dropzone background
    },
    previewRemoving: {
      animation: `$fadeOutScale 0.15s ${Easings.easeOut} forwards`,
    },
    // Compact preview - narrower width, same height
    previewCompact: {
      flex: 'none', // Don't stretch to fill
      width: 120, // Fixed narrow width
      height: '100%', // Fill parent height
      [`@media (max-width: ${Breakpoints.xs}px)`]: {
        width: 100,
      },
    },
    previewMedia: {
      display: 'block',
      width: '100%',
      height: '100%',
      position: 'absolute',
      top: 0,
      left: 0,
      objectFit: 'cover', // Fill the box, cropping if needed
      borderRadius: CornerRadius.r12,
    },
    removeButton: {
      position: 'absolute',
      top: Spacings.s8,
      right: Spacings.s8,
      display: 'inline-flex',
      zIndex: 2,
    },
    iconButton: {
      width: Spacings.s32,
      height: Spacings.s32,
      flex: `0 0 ${Spacings.s32}`,
      borderRadius: CornerRadius.circle,
      backgroundColor: Effects.alpha50,
      color: AbsoluteWhiteColors.base.default,
      border: 'none',
      [canHover]: {
        '&:hover': {
          backgroundColor: Effects.alpha80,
        },
      },
    },
    loadingOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: Effects.alpha50,
    },
  },
  { name: 'file-preview' }
);

export default useStyles;
